import { render, staticRenderFns } from "./NewMerchantForm.vue?vue&type=template&id=2a38e75a&"
import script from "./NewMerchantForm.vue?vue&type=script&lang=js&"
export * from "./NewMerchantForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports